export interface FAQ {
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    question: '福利导航是什么？',
    answer: '福利导航是一站式福利资源聚合平台，致力于为中文用户精准聚合各类福利信息，涵盖优惠券、会员权益、生活补贴、职场福利、教育福利、健康福利、旅游福利、金融福利等多维度内容。我们帮助用户发现最新最全的福利资源，节省时间与金钱。',
  },
  {
    question: '福利导航的信息来源可靠吗？',
    answer: '我们的编辑团队每天关注各级政府官网、企业官方公告、主流电商平台等权威信息源，所有福利信息均经过人工核实后方才发布。每条信息都会标注来源和有效期，确保用户获取的是真实可靠的福利内容。',
  },
  {
    question: '如何快速找到自己需要的福利信息？',
    answer: '你可以通过首页的分类导航快速定位感兴趣的福利类别，也可以在搜索框中输入关键词进行搜索。我们还会在首页推荐精选福利文章，每周更新热门福利汇总，帮助你不错过任何重要福利。',
  },
  {
    question: '福利导航是否收费？',
    answer: '福利导航完全免费！我们的使命是让更多人享受到应有的福利权益。平台通过广告和推荐联盟维持运营，用户无需支付任何费用即可浏览所有福利信息。',
  },
  {
    question: '如何订阅福利更新通知？',
    answer: '你可以通过页面底部的邮件订阅功能，输入邮箱地址即可每周接收福利精选周报。我们承诺不会发送垃圾邮件，且订阅后可以随时取消。',
  },
  {
    question: '发现有错误或过时的信息怎么办？',
    answer: '我们非常重视信息的准确性。如果你发现任何错误或过时的福利信息，请通过关于我们页面的联系方式或邮件 contact@fulidaohang.com 告知我们，我们会在24小时内核实并更新。',
  },
  {
    question: '福利导航支持哪些类型的福利？',
    answer: '目前福利导航已覆盖8大福利类别：优惠券、会员权益、生活补贴、职场福利、教育福利、健康福利、旅游福利和金融福利。我们将持续拓展新的类别，如你有建议欢迎反馈。',
  },
  {
    question: '企业可以在福利导航发布福利信息吗？',
    answer: '可以的。如果你的企业有为员工或用户提供福利资源，欢迎通过关于我们页面的联系方式与我们取得联系。经审核确认后，我们可以协助发布相关信息。',
  },
];